import { modifyError } from "../../../Validation/ModifyErrros";
import Api from "../../../Api";
// import { modifyError } from "../../Validation/ModifyErrros";

export const createActivityCategory = async (data) => {
  try {
    let res = await Api.post("/activity-category-master", data);
    return res?.data;
  } catch (e) {
    return { error: "Something Wrong" };
  }
};

export const checkParentCat = async (data) => {
  try {
    let res = await Api.post("/activity-category-master/check-parent-cat", data);
    return res?.data;
  } catch (e) {
    return { error: "Something Wrong" };
  }
};
export const addParentCat = async (data) => {
  try {
    let res = await Api.post("/activity-category-master/add-parent-cat", data);
    return res?.data;
  } catch (e) {
    return { error: "Something Wrong" };
  }
};

export const getActivityCategory = async (query) => {
  try {
    let res = await Api.get("/activity-category-master", {
      params: query,
    });

    return res?.data || [];
  } catch (e) {
    return { error: "Something Wrong" };
  }
};

export const getCategoryOption = async (query) => {
  try {
    let res = await Api.get("/activity-category-master/getOption", {
      params: query,
    });

    return res?.data || [];
  } catch (e) {
    return { error: "Something Wrong" };
  }
};

export const getOneActivityCategory = async (id) => {
  try {
    let res = await Api.get("/activity-category-master/" + id);

    return res?.data || [];
  } catch (e) {
    return { error: "Something Wrong" };
  }
};

export const deleteActivityCategory = async (id) => {
  try {
    let res = await Api.delete("/activity-category-master/" + id);

    return res?.data || [];
  } catch (e) {
    return { error: "Failed to delete" };
  }
};

export const updateActivityCategory = async (id, data) => {
  try {
    let res = await Api.patch("/activity-category-master/" + id, data);

    return res?.data || [];
  } catch (e) {
    return { error: "Failed to Update" };
  }
};
export const updateActivitySingleCategory = async (id, data) => {
  try {
    let res = await Api.patch("/activity-category-master/update/" + id, data);

    return res?.data || [];
  } catch (e) {
    return { error: "Failed to Update" };
  }
};

export const updatePosition = async (banners, query) => {
  try {
    let res = await Api.patch(
      "/activity-category-master/relocate-position",
      banners,
      {
        params: query,
      }
    );

    return res?.data || [];
  } catch (e) {
    let error = modifyError(e);
    return { error: error.message };
  }
};
